<article class="metric-card" [class.compact]="compact()">
  <div class="metric-top">
    <p class="metric-label">{{ label() }}</p>
    <span class="metric-icon" aria-hidden="true">
      <i [ngClass]="iconClass()"></i>
    </span>
  </div>

  <div class="metric-value">
    {{ value() }}
    @if (valueSuffix()) {
      <span class="value-suffix">{{ valueSuffix() }}</span>
    }
  </div>

  @if (subtitle()) {
    <p class="metric-subtitle">{{ subtitle() }}</p>
  }
</article>
